import * as actionTypes from '../actionTypes/organization';

export default {
  updateOrganization: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_ORGANIZATION_DETAILS,
      payload: params,
    };
    dispatch(actionData);
  },
};
